import { ThemeProvider } from "@mui/material";
import { AppTheme } from "./themes/AppTheme";
import { QueryClient, QueryClientProvider } from "react-query";
import { Fragment } from "react";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "./components/DashboardLayout";
import { HomeDash } from "./components/HomeDash";
import LoginPage from "./components/auths/LoginPage";
import { UserProvider } from "./context/UserProvider";
import { UserAuth } from "./utils/util";
import { ADMIN } from "./utils/constants";
import Logout from "./components/auths/LogOut";

const queryClient = new QueryClient();

const App = () => {
  return (
    <ThemeProvider theme={AppTheme}>
      <QueryClientProvider client={queryClient}>
        <Fragment>
          <BrowserRouter>
            <ToastContainer autoClose={1500} />
            <Routes>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/logout" element={<Logout />} />
              <Route
                path="/home/*"
                element={
                  <UserProvider>
                    <UserAuth type={ADMIN}>
                      <HomeDash />
                    </UserAuth>
                  </UserProvider>
                }
              />
            </Routes>
          </BrowserRouter>
        </Fragment>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
